import { render, staticRenderFns } from "./RankingTeamCard.vue?vue&type=template&id=15223a4c&scoped=true&"
import script from "./RankingTeamCard.vue?vue&type=script&lang=js&"
export * from "./RankingTeamCard.vue?vue&type=script&lang=js&"
import style0 from "./RankingTeamCard.vue?vue&type=style&index=0&id=15223a4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15223a4c",
  null
  
)

export default component.exports